import { useEffect, useRef } from "react";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import useModal from "../../hooks/useModal";
import { useForm } from "react-hook-form";
import { AccountService } from "../../services/AccountsService";
import { AlertService } from "../../services/Alert";
import { useTranslation } from "react-i18next";

interface AccountFormModalProps {
    show: boolean;
    type: 'create' | 'licences' | 'waweb';
    data?: any;
    onRequestClose: (refresh: boolean) => void;
}


function AccountFormModal({ show, type, data, onRequestClose }: AccountFormModalProps) {

    const { t } = useTranslation();

    const modal = useRef<HTMLDivElement>(null);

    useModal(modal, show)

    const defaultValues = {
        account_id: '',
        name: '',
        licenses: '',
        waweb: false,
        number: '',
        ip_server: '',
        port_server: '',
    }

    const { register, watch, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });
    const is_waweb = watch('waweb')


    const submit = async (data) => {
        try {
            data.waweb = data.waweb ? 1: 0;

            if( type === 'create' ) {
                await AccountService.createAccount(data)
            } else if( type === 'waweb' ) {
                await AccountService.wawebEdit({
                    account_id: data.account_id,
                    waweb: data.waweb,
                    number: data.number,
                    ip_server: data.ip_server,
                    port_server: data.port_server,
                })
            } else if( type === 'licences' ) {
                await AccountService.editLicences({
                    account_id: data.account_id,
                    licenses: data.licenses,
                })
            }           
            
            
            reset(defaultValues)

            AlertService.toastSuccess('Se guardó correctamente la cuenta')
            
            onRequestClose(true)
            
        } catch (error) {
            console.error(error)
            AlertService.error('¡Error!', 'No se pudo guardar la cuenta, intenta más tarde.')
        }
    }

    const handleDefaultValues = () => {
        if(type === 'licences' || type === 'waweb') {
            reset({
                account_id: data.account_id,
                name: data.name,
                licenses: `${data.licenses}`,
                waweb: !(data.waweb_status.toLowerCase() === 'inactivo'),
                number: data.waweb_status.toLowerCase() === 'inactivo' ? '': `${data.waweb_number}`,
                ip_server: data.waweb_status.toLowerCase() === 'inactivo' ? '': `${data.waweb_server}`,
                port_server: '',
            })
        } else {
            reset(defaultValues)
        }
    }

    useEffect(() => {
      if(show) {
        handleDefaultValues()
        
      }
    }, [show])
    

    return (
        <div className="modal fade" ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            { type === 'create' && <h4 className="modal-title">{t("platform.accounts.add-account")}</h4>}
                            { type === 'licences' && <h4 className="modal-title">{t("platform.accounts.add-licenses")}</h4>}
                            { type === 'waweb' && <h4 className="modal-title">{t("platform.accounts.enable-disable")}</h4>}
                            <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                        </div>
                        <div className="modal-body">

                            <div className="mb-3">
                                <Input label={t("platform.accounts.name-label")} errors={errors.name} {...register('name', { disabled: !(type === 'create'), required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                            {
                                (type === 'create' || type === 'licences') && (
                                    <div className="mb-3">
                                        <Input label={t("platform.accounts.licenses-label")} errors={errors.licenses} {...register('licenses', { required: true, setValueAs: (value) => value.trim() })} />
                                    </div>
                                )
                            }

                            

                            {
                                (type === 'create' || type === 'waweb') && (
                                    <>
                                        <div className="form-check mb-3">
                                            <input type="checkbox" id="is_waweb" className="form-check-input" {...register('waweb', { })} />
                                            <label className="form-check-label" htmlFor="is_waweb">{t("platform.accounts.is-standard")}</label>
                                        </div>
                                        
                                        {
                                            is_waweb && (
                                                <>
                                                    <div className="mb-3">
                                                        <Input label= {t("platform.accounts.number")} errors={errors.number} {...register('number', { required: true, setValueAs: (value) => value.trim() })} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <Input label={t("platform.accounts.ip")} errors={errors.ip_server} {...register('ip_server', { required: true, setValueAs: (value) => value.trim() })} />
                                                    </div>
                                                    <div className="mb-3">
                                                        <Input label={t("platform.accounts.port")} errors={errors.port_server} {...register('port_server', { required: true, setValueAs: (value) => value.trim() })} />
                                                    </div>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => onRequestClose(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default AccountFormModal